import ApiService from '../ApiService';
import Axios from 'axios';

const AppointmentService = {

    statesAppointment(countryId) {
        countryId = countryId || 1;
        return ApiService.customRequest({
            url: `${ApiService.farmadomiciliosApiURL}/state/search-state-by-branch/${countryId}`
        });
    },
    cityAppointment(cityId) {
        cityId = cityId || 1;
        return ApiService.customRequest({
            url: `${ApiService.farmadomiciliosApiURL}/city/by-state-branch/${cityId}`
        });
    },
    getBranchesAppointment(sedeId) {
        sedeId = sedeId || 0;
        return ApiService.customRequest({
            url: `${ApiService.farmadomiciliosApiURL}/branch/get-all-branch-by-delivery-point/${sedeId}`
        });
    },
    getDayAttentionByBranch(idBranch) {
        return ApiService.customRequest({
            url: `${ApiService.farmadomiciliosApiURL}/appointment/get-day-attention-by-branch/${idBranch}`
        })
    },

    getCalendarAppointment(idBranch, day) {
        return ApiService.customRequest({
            url: `${ApiService.farmadomiciliosApiURL}/appointment/get-shifts-by-delivey-point/${idBranch}/day/${day}`
        })
    },
    saveAppointment(data) {
        return ApiService.customRequest({
            url: `${ApiService.farmadomiciliosApiURL}/scheduling/`,
            data,
            method: 'POST'
        })
    }

}
export default AppointmentService;
